import Typography from 'components/Typography'
import styled from 'styled-components'

export const TitlePanel = styled(Typography)`
  font-weight: 500;
`
